// extracted by mini-css-extract-plugin
export default {"guidelineWrapper":"cTS90Oa6TpVTOgTs0a_I","emojiWrapper":"c7dMzNFz17kTB6iJLC8S","guidelineText":"yB7RMWu1J7EKSuMGLN8M"};